import { render, staticRenderFns } from "./newAddOrEditDialog.vue?vue&type=template&id=492595c1&scoped=true&"
import script from "./newAddOrEditDialog.vue?vue&type=script&lang=js&"
export * from "./newAddOrEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./newAddOrEditDialog.vue?vue&type=style&index=0&id=492595c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492595c1",
  null
  
)

export default component.exports